import { useState } from 'react';
import { useAuth } from '../../context/AuthContext';
import { useNavigate } from 'react-router-dom';

export default function DashboardLogin() {
  const { login, state } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState<string | null>(null);
  const [submitting, setSubmitting] = useState(false);
  const supabaseConfigured = Boolean(import.meta.env.VITE_SUPABASE_URL && import.meta.env.VITE_SUPABASE_ANON_KEY);

  async function handleSubmit(e: React.FormEvent) {
    e.preventDefault();
    setSubmitting(true);
    setError(null);
    try {
      if (!supabaseConfigured) throw new Error('Supabase is not configured');
      await login({ type: 'email', credentials: { email, password } });
      navigate('/dashboard', { replace: true });
    } catch (err: any) {
      const rawMessage = (err?.message || '').toString().toLowerCase();
      if (rawMessage.includes('invalid login credentials')) {
        setError('Λάθος email ή κωδικός.');
      } else if (rawMessage.includes('email not confirmed')) {
        setError('Το email δεν έχει επιβεβαιωθεί.');
      } else {
        setError('Η σύνδεση απέτυχε.');
      }
    } finally {
      setSubmitting(false);
    }
  }

  return (
    <div className="min-h-screen bg-black text-white flex items-center justify-center px-4">
      <div className="w-full max-w-md bg-gray-900 border border-gray-800 rounded-xl p-6 shadow-xl">
        <h1 className="text-2xl font-semibold mb-2">Σύνδεση Πίνακα</h1>
        <p className="text-sm text-gray-400 mb-6">Πρόσβαση στον πίνακα καλλιτέχνη ή διαχείρισης.</p>
        <form onSubmit={handleSubmit} className="space-y-4">
          <div>
            <label htmlFor="dash-email" className="block text-sm text-gray-300 mb-1">Email</label>
            <input
              id="dash-email"
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              className="w-full rounded-md bg-black/40 border border-gray-700 px-3 py-2 text-white"
            />
          </div>
          <div>
            <label htmlFor="dash-password" className="block text-sm text-gray-300 mb-1">Κωδικός</label>
            <input
              id="dash-password"
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              className="w-full rounded-md bg-black/40 border border-gray-700 px-3 py-2 text-white"
            />
          </div>
          {error && <p className="text-sm text-red-400">{error}</p>}
          {!supabaseConfigured && (
            <p className="text-xs text-yellow-400">Το Supabase δεν έχει ρυθμιστεί.</p>
          )}
          <button
            disabled={submitting || state.loading}
            className="w-full bg-pink-600 hover:bg-pink-700 disabled:opacity-50 text-white font-semibold rounded-md py-2"
          >
            Σύνδεση
          </button>
        </form>
      </div>
    </div>
  );
}
